<router-outlet></router-outlet>
<miq-maintenance-banner *ngIf="showMaintenanceBanner"></miq-maintenance-banner>
